import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../FontKeys';
import Creature from '../game/Creature';
import Ghost from '../game/Ghost';
import Popup from '../game/Popup';
import Sky from '../game/Sky';
import gameData from '../gameData';
import ABCyaLib from '@abcya/abcya_lib';

/**
 * This is your first scene.
 */
export default class Intro extends Phaser.Scene
{
    static get KEY() { return 'Intro'; }

    create()
    {
        // console.log("CREATING INTRO", gameData.DESKTOP);

        ABCyaPhaser.Audio.playOneShot("Jingle_Ghost_Typing", this, .1, true);

        this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

        gameData.GAME_STATE = "intro";

        this.txtCounter = 0;

        this.ghostArray = [];
        this.batArray = [];

        this.createBG();
    }

    createBG()
    {
        //create the needed assets for bg and intro
        this.bg = gameData.DESKTOP ? ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, "bground", this) : ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, "bgroundM", this);

        this.sky = new Sky(this);

        this.houseB = ABCyaPhaser.Images.addImage(0, 0, "houseBack", this);
        this.houseB.name = "houseBack";
        this.houseF = ABCyaPhaser.Images.addImage(0, 0, "houseFront", this);
        this.houseF.name = "houseFront";

        const newY = gameData.DESKTOP ? this.mid.y*2 - this.houseB.height/2 - 120 : this.mid.y*2 - this.houseB.height/2 - 300;
        this.houseB.setPosition(this.mid.x*2 - this.houseB.width/2 - 30, newY);
        this.houseF.setPosition(this.houseB.x + 35, this.houseB.y + 100);

        this.createCreatures(5);
        this.createGhosts();
        this.createNav();

        this.sky.skyIntro();
    }

    createGhosts(){
        //create the ghosts and position them
       for(let b = 1; b <= 2; b++){
           const ghost = new Ghost(this, b, this);
           this.ghostArray.push(ghost);
       }
       const ghost2 = new Ghost(this, 3, this);
       this.ghostArray.push(ghost2);
    };

    createCreatures(amnt){
        //create the bats and position them
        for(let b = 1; b <= amnt; b++){
            const bat = new Creature(this, "bat", b, amnt)
            this.batArray.push(bat);
        }
    };

    createNav(){
        //create the navigation and title
        this.title = ABCyaPhaser.Images.addImage(0, 0,"ghostType", this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setAlpha(0);
        this.btnPlay = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "btnPlay", null, ()=>{
            ABCyaPhaser.Audio.playOneShot("Click", this);
           this.btnPlay.setEnabled(false);
           this.showPopup();
        }, this).setEnabled(false).setAlpha(0);

        this.txt = " ";
        const fontSize = ABCyaLib.Environment.instance.locale !== "es-US" ? 80 : 50;
        this.introText = ABCyaPhaser.Text.addText(0, 0, fontSize, "0xFFFFFF", FontKeys._sanchez_regular, this.txt, this, false);

        if(ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS) {
          this.title.setPosition(this.title.width/2 + 50, this.title.height/2 + 110);
          this.introText.setPosition(38, this.title.y - (this.title.height/2 + 65));
        }
        else {
          this.title.setPosition(this.title.width/2 + 50, this.title.height/2 + 50);
          this.introText.setPosition(80, this.title.y + this.title.height/2 + 15);
        }

        ABCyaPhaser.Tweens.addTween(this.title, 1000, {alpha:1, delay:1000}, Phaser.Math.Easing.Linear, ()=>{
           this.startNavIntro();
        });
    };

    startNavIntro(){
        this.txtCounter++;

        const typingWord = ABCyaPhaser.Localization.instance.getLocalizedString("title.dynamic_part");
        this.txt = " " + typingWord.slice(0, this.txtCounter).split("").join(" ");
        this.introText.text = this.txt;

        ABCyaPhaser.Audio.playOneShot("TypeWriter", this);
        
        if(this.txtCounter < typingWord.length){
            this.time.delayedCall(ABCyaLib.Environment.instance.locale !== "es-US" ? 350 : 250, ()=>{this.startNavIntro();});
        }
        if(this.txtCounter == typingWord.length){
            const newX = gameData.DESKTOP ? this.title.x : this.title.x - 50;
            this.btnPlay.setPosition(newX, 444);

           ABCyaPhaser.Tweens.addTween(this.btnPlay, 1000, {alpha:1}, Phaser.Math.Easing.Linear, ()=>{this.btnPlay.setEnabled(true);});
        }
    };

    showPopup(){
        ABCyaPhaser.Audio.playOneShot("Click", this);

        this.popup = new Popup(this);
    };

    destroyIntro(){
        this.tweens.killAll();

        for(var b = 0; b < this.batArray.length; b++){
            this.batArray[b].isOver = true;
            this.batArray[b].destroyCreature();
            this.batArray[b].destroy();
        }

        for(var g = 0; g < this.ghostArray.length; g++){
            this.ghostArray[g].destroyCreature();
            this.ghostArray[g].destroy();
        }

        this.popup.destroyPopup();
        this.sky.destroySky();

        this.title.destroy();
        this.bg.destroy();
        this.btnPlay.destroy();
        this.houseB.destroy();
        this.houseF.destroy();
        this.introText.destroy();

        this.batArray = [];
        this.ghostArray = [];

        this.scene.start("Game");
    };
}